<template>
  <div>
    <BListFilter
      v-model="form"
      label="Поиск по названию и описанию"
      :skeleton="skeleton"
      dense
      @change="onChangeDebounced"
    />
  </div>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'

const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  is_archived: null,
})

export default {
  name: 'PublicationsFilter',
  components: {
    BListFilter,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
}
</script>
